export class NewAppVersionAvailableEvent {
  constructor() {}
}
